var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-block-content-props"},_vm._l((_vm.props),function(prop){return _c('admin-block-content-prop',_vm._b({key:prop.id},'admin-block-content-prop',prop,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }